<template>
  <v-row class="fill-height">
    <v-col class="py-0">
      <v-sheet height="64">
        <v-toolbar flat color="primary">
          <!-- <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday()"> Today </v-btn> -->
          <div class="d-flex align-center" style="flex: 1">
            <v-btn fab class="mx-2" small color="white" elevation="0" @click="prev()">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab small color="white" elevation="0" @click="next()">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-toolbar-title class="ms-2 white--text"> {{ currentMonth }} </v-toolbar-title>
          </div>

          <div class="d-flex align-center white--text">
            <v-icon left color="white">mdi-calendar-month</v-icon>
            APPOINTMENTS CALENDAR
          </div>
          <!-- FORM TO CREATE TIME SLOTS -->
          <TimeSlotsModalForm v-if="canViewAppointmentModal" @getCalendarEntriesParent="getCalendarEntries" style="flex: 1" />
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600" class="calendar-wrapper">
        <div class="loader-wrapper" v-if="loading">
          <v-progress-circular indeterminate color="primary"> </v-progress-circular>
        </div>
        <v-calendar
          ref="calendar"
          v-model="focus"
          class="appointment-calendar"
          color="accent"
          :type="type"
          :event-more="false"
          :events="events"
          :event-color="getEventColor"
          :show-month-on-first="false"
          @click:date="dateClick($event)"
          @click:day="dateClick($event)"
          @change="calendarChanged($event)"
        ></v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import TimeSlotsModalForm from '@/views/AppointmentsCalendarPage/components/time-slots-modal-form.vue';

export default {
  mixins: [SharedFunctions],
  components: { TimeSlotsModalForm },
  data: () => ({
    canViewAppointmentModal: false,
    currentMonth: null,
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    }
  }),
  computed: {
    user() {
      return this.$store.state.config.userObject;
    },
    events() {
      return this.$store.state.appointmentsCalendarStore.appointmentsCalendarPage.calendarEvents;
    },
    loading() {
      return this.$store.state.appointmentsCalendarStore.appointmentsCalendarPage.calendarLoader;
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(n) {
        if (n) this.checkUserRole();
      }
    }
  },
  methods: {
    checkUserRole() {
      if (this.userHasRole('service-center-create-timeslots')) this.canViewAppointmentModal = true;
      else this.canViewAppointmentModal = false;
    },
    dateClick(event) {
      if (!this.userHasRole('service-center-create-timeslots')) {
        this.$store.commit('SET_SNACKBAR', { open: true, text: 'User does not have permission to create time slots', color: 'warning' });
        return;
      }
      let eventsOnClickedDay = this.events.filter((item) => item.start == event.date);
      //if events set on date
      if (eventsOnClickedDay.length > 0) {
        this.$store.commit('appointmentsCalendarStore/SET_CLICKED_DATE', null);
        this.$router.push({
          name: 'AppointmentsSelectedDayPage',
          params: { selectedDate: event.date }
        });
      }
      //date before today and empty
      else if (eventsOnClickedDay.length == 0 && this.isBeforeToday(event.date)) {
        this.$store.commit('SET_SNACKBAR', { open: true, text: "Can't create timeslots on a day earlier than today", color: 'warning' });
      }
      //day empty, prefill startdate
      else {
        //reset incase person clicks same day
        this.$store.commit('appointmentsCalendarStore/SET_CLICKED_DATE', null);
        setTimeout(() => {
          this.$store.commit('appointmentsCalendarStore/SET_CLICKED_DATE', event.date);
          this.$store.commit('appointmentsCalendarStore/SET_TIME_SLOT_DIALOG', true);
        }, 0);
      }
    },
    setToday() {
      this.focus = '';
    },
    next() {
      this.$refs.calendar.next();
    },
    prev() {
      this.$refs.calendar.prev();
    },
    async calendarChanged(event) {
      this.currentMonth = moment(event.start.month, 'MM').format('MMMM');
      this.$store.commit('appointmentsCalendarStore/SET_CURRENT_CALENDAR_EVENT_RANGE', event);
      this.$emit('getCalendarEntriesParent');
    },
    getCalendarEntries() {
      this.$emit('getCalendarEntriesParent');
    },
    getEventColor(event) {
      return event.color;
    },
    isBeforeToday(date) {
      if (moment(date, 'YYYY-MM-DD').isBefore(moment(), 'day')) return true;
      else return false;
    }
  }
};
</script>

<style lang="scss">
.calendar-wrapper {
  position: relative;
  .loader-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(white, 0.7);
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .appointment-calendar {
    .v-btn--fab.v-size--small {
      height: 24px;
      width: 24px;
    }
  }
  .v-calendar-weekly__day:hover {
    cursor: pointer;
    background: whitesmoke;
  }
  .v-calendar-weekly__day.v-outside {
    pointer-events: none;
  }
}
</style>